import { LinkButton, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { EProgramType, IProgram } from '../../types/suburban';
import { HEADERS } from './constants';
import * as styles from './MortgageProgramTable.css';
import cn from 'classnames';
import { MortgageProgramDescription } from '../MortgageProgramDescription';
import { MORTGAGE_LINK } from '../../constants/suburban';

interface IMortgageProgramTableProps {
  items: IProgram[];
  onButtonClick(id: EProgramType): void;
}

export const MortgageProgramTable: React.VFC<IMortgageProgramTableProps> = ({ items, onButtonClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        {HEADERS.map((header, index) => (
          <UIText2 key={index} color="gray40_100">
            {header}
          </UIText2>
        ))}
      </div>
      {items.map(({ id, name, description, rate, creditLimitMillions, termYears, isUntilRate }) => (
        <div key={id} className={styles['row']}>
          <div className={cn(styles['info-cell'])}>
            <div className={cn(styles['icon'], styles[`${id}-icon`])} />
            <div>
              <div className={styles['name']}>
                <UIText1>{name}</UIText1>
              </div>
              <MortgageProgramDescription description={description} />
            </div>
          </div>
          <UIText1>
            {isUntilRate ? 'до' : 'от'} {rate}%
          </UIText1>
          <UIText1>до {creditLimitMillions} млн ₽</UIText1>
          <UIText1>до {termYears} лет</UIText1>
          <LinkButton
            theme="fill_secondary"
            size="XS"
            href={MORTGAGE_LINK}
            target="_blank"
            onClick={() => onButtonClick(id)}
          >
            Получить онлайн
          </LinkButton>
        </div>
      ))}
    </div>
  );
};
